module.exports = __webpack_public_path__ + "static/media/advertising_guide.a171aafa.pdf";